export default __webpack_public_path__ + "static/bg-449d76d68fffd65e70cba92f38b7d80c.svg";